import { IWellheadCost } from '../../interfaces/iwellhead-cost';
import { UnitOfMeasure } from '../unit-of-measure';
import { Vendor } from '../vendor';
import { WellheadSection } from '../wellhead-section';

export class WellheadCostBase {
  WellheadCostId: number;
  WellheadSectionId: number;
  VendorId: number;
  DrillingItemId: number;
  UnitCost: number;
  UnitOfMeasureId: number;
  Quantity: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  UnitOfMeasure?: UnitOfMeasure;
  Vendor?: Vendor;
  WellheadSection?: WellheadSection;

  constructor(item?: IWellheadCost) {
    if (item) {
      this.WellheadCostId = item.WellheadCostId;
      this.WellheadSectionId = item.WellheadSectionId;
      this.VendorId = item.VendorId;
      this.DrillingItemId = item.DrillingItemId;
      this.UnitCost = item.UnitCost;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.Quantity = item.Quantity;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
      this.Vendor = new Vendor(item.Vendor);
      this.WellheadSection = new WellheadSection(item.WellheadSection);

    }
  }
}